export default "__VITE_ASSET__C7X0w4NU__"